import { render, staticRenderFns } from "./ships-dates-prices-row.vue?vue&type=template&id=4d04a150"
import script from "./ships-dates-prices-row.vue?vue&type=script&lang=js"
export * from "./ships-dates-prices-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports